<template>
  <div class="min-h-screen flex items-center justify-center bg-white px-4">
    <div class="max-w-md w-full text-center">
      <!-- Icon -->
      <div class="w-16 h-16 mx-auto mb-6 bg-stone-100 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      </div>

      <!-- Error Code -->
      <p class="text-xs uppercase tracking-[0.3em] text-gray-500 mb-2">{{ $t('access_denied.error_code') }}</p>

      <!-- Title -->
      <h1 class="text-2xl md:text-3xl font-light text-gray-900 mb-4">
        {{ $t('access_denied.title') }}
      </h1>

      <!-- Message -->
      <p class="text-gray-600 text-sm mb-2">
        {{ $t('access_denied.message') }}
      </p>
      <p class="text-xs text-gray-500 mb-8">
        {{ $t('access_denied.restricted') }}
      </p>

      <!-- Actions -->
      <div class="space-y-3">
        <router-link 
          to="/" 
          class="inline-flex items-center justify-center w-full px-6 py-3 bg-gray-900 text-white text-sm font-medium tracking-wide hover:bg-gray-800 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          {{ $t('access_denied.go_home') }}
        </router-link>

        <button 
          v-if="authStore.isAuthenticated"
          @click="logout"
          class="inline-flex items-center justify-center w-full px-6 py-3 border border-gray-300 text-gray-700 text-sm font-medium tracking-wide hover:bg-gray-50 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          {{ $t('access_denied.logout') }}
        </button>
      </div>

      <!-- Contact Info -->
      <p class="mt-8 text-xs text-gray-500 uppercase tracking-wider">
        {{ $t('access_denied.need_access') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'

const { t: $t } = useI18n()
const authStore = useAuthStore()
const router = useRouter()

async function logout() {
  await authStore.logout()
  router.push('/')
}
</script>
